import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_paper_all: FaireCategoryEntity = {
  token: "cat_paper-all",
  type: "category",
  name: "All paper & novelty",
  level: 2,
  parentToken: "cat_paper-novelty",
  href: "/category/paper-novelty",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
